export enum MarkedForDeletion {
  NO, YES
}
